import { IAppState } from '../../../../../../common/context/context'
import { selectSearchNeumaticos } from '../../../searchNeumaticos.store'

export const selectTallerState = (state: IAppState) =>
  selectSearchNeumaticos(state).taller
export const selectTallerSeleccionado = (state: IAppState) =>
  selectSearchNeumaticos(state).taller.tallerSeleccionado
export const selectTalleresEncontrados = (state: IAppState) =>
  selectSearchNeumaticos(state).taller.talleresEncontrados
export const selectModalTallerAbierto = (state: IAppState) =>
  selectSearchNeumaticos(state).taller.modalAbierto
